import React from "react";

import VideoGuideRunner from "../base/VideoGuideRunner";

import triStateVideoGuides from "./configuration";

const TriStateVideoGuides = () => (
  <>
    {triStateVideoGuides.map((descriptor) => (
      <VideoGuideRunner descriptor={descriptor} key={descriptor.id} />
    ))}
  </>
);

export default TriStateVideoGuides;
